import { AgencyV2ClientPageLayout } from 'components/layouts/AgencyV2ClientPageLayout'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import CreateNativeAdForm from '../CreateNativeAdForm'
import DisplayAdUploader from '../DisplayAdUploader'

interface CreateAdInternetRetailPageParams {
  step: string
}

enum AgencyV2CreateAdStep {
  Start = 'start',
  Upload = 'upload',
}

export const AgencyV2InternetAdCreate = () => {
  const { step } = useParams<CreateAdInternetRetailPageParams>()
  const [helmetTitle, setHelmetTitle] = useState('')
  const [panelTitle, setPanelTitle] = useState('')

  useEffect(() => {
    switch (step) {
      case AgencyV2CreateAdStep.Start:
        setHelmetTitle('Create Native Ad')
        setPanelTitle('Create Native Ad')
        break
      case AgencyV2CreateAdStep.Upload:
        setHelmetTitle('Upload Display Ad')
        setPanelTitle('Upload Display Ad')
        break
    }
  }, [step])

  return (
    <AgencyV2ClientPageLayout helmetTitle={helmetTitle} panelTitle={panelTitle}>
      {step === AgencyV2CreateAdStep.Start && <CreateNativeAdForm />}
      {step === AgencyV2CreateAdStep.Upload && <DisplayAdUploader />}
    </AgencyV2ClientPageLayout>
  )
}